// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__ARQmK","github":"NavItem_github__1D1yV","underline":"NavItem_underline__15Hr4"};